import { _sharedActionsConstantsParagraphs } from "./actions";
import { getBookIdNumber } from "../../utils/content/content";

export const _sharedStateParagraphs = {
  paragraphs: {},
  chaptersParas: {},
};

export const _sharedReducerParagraphs = (state = _sharedStateParagraphs, action) => {
  switch (action.type) {
    case _sharedActionsConstantsParagraphs.FETCH_PARAGRAPHS_SUCCESS:
      return {
        ...state,
        paragraphs: {
          ...state.paragraphs,
          [action.data.nBookId]: action.data.parasObj,
        },
      };
    case _sharedActionsConstantsParagraphs.FETCH_CHAPTER_PARAS_SUCCESS: {
      const {chapterId, paras, highlight} = action.data;
      const bookIdOrigin = getBookIdNumber(chapterId);
      const chapterNumber = chapterId.split(".")[1];

      const chapterParasCurrent = state.chaptersParas[bookIdOrigin]?.[chapterNumber];
      if (chapterParasCurrent && chapterParasCurrent.highlight === highlight) {
        return state;
      }

      const bookChaptersParasNew = state.chaptersParas[bookIdOrigin]
        ? {
          ...state.chaptersParas[bookIdOrigin],
          [chapterNumber]: { paras, highlight },
        }
        : { [chapterNumber]: { paras, highlight } };

      return {
        ...state,
        chaptersParas: {
          ...state.chaptersParas,
          [bookIdOrigin]: bookChaptersParasNew,
        },
      };
    }
    case _sharedActionsConstantsParagraphs.FETCH_CHAPTERS_PARAS_SUCCESS: {
      const { bookIdOrigin, mapChapterNumberToParas } = action.data;

      const bookChaptersParasCurrent = state.chaptersParas[bookIdOrigin];

      if (!bookChaptersParasCurrent) {
        return {
          ...state,
          chaptersParas: {
            ...state.chaptersParas,
            [bookIdOrigin]: mapChapterNumberToParas,
          }
        };
      }

      const bookChaptersParasNumbersCurrent = Object.keys(bookChaptersParasCurrent);
      const chaptersParasNumbers = Object.keys(mapChapterNumberToParas);

      if (chaptersParasNumbers.some((i) => !bookChaptersParasNumbersCurrent.includes(i))) {
        return {
          ...state,
          chaptersParas: {
            ...state.chaptersParas,
            [bookIdOrigin]: mapChapterNumberToParas,
          }
        };
      }

      return state;
    }
    case _sharedActionsConstantsParagraphs.CLEAR_BOOK_PARAS: {
      let paragraphsNew;

      if (action.data) {
        paragraphsNew = { ...state.paragraphs };
        delete paragraphsNew[action.data];
      } else {
        paragraphsNew = {};
      }

      return {
        ...state,
        paragraphs: paragraphsNew,
      };
    }
    default:
      return state;
  }
};
